import store from '@/config/vuex/store'
import api from '@/api/support'
const userCheck = async (user)=> {
    let checked = await api.loginUser(user).then(function(res){
        if(res && res.data.code === 1000) {
            return res.data.content
        } else {
            return null
        }
    }).catch(function() {
        return null
    })

    if(checked){
        store.dispatch('auth/setUser',{data:checked,ts:null})
    }
    return checked
}

export default userCheck
